<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col cols="4" lg="6">
        <!--Display Trash or Normal Table View-->
        <h2>Haul Invoices</h2>
       <!--  <h2 v-show="!trash">Hauls</h2>
       <h2 v-show="trash">Hauls - Trash</h2>-->
      </b-col>

      <!--Gear Icon :data            :data   = "items_csv"      @click="openExcel()"          = "items"   ref="excel"   v-b-popover.hover.top="'Export to csv'"   @click="openExcel()"         :data   = "items" -->
      <b-col cols="8" lg="6">
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="openSelectColumns()"><i class="fa fa-cog"></i></b-btn>
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Activate/Deactivate bbl'" variant="info" @click="bbl()"><i class="fa fa-bullseye"></i></b-btn> 
        <b-btn v-if="role !='analyst' || role !='marketing_accountant'" class="pull-right" variant="info" @click="send_notification_click()"><i class="fa fa-send"></i></b-btn>
      </b-col> 

    </div>

    <!-- Filters block  style=" padding-top: 3px; padding-bottom: 3px;" sm="7" md="6" lg="5"-->
    <div class="filters pb-2">
      <b-row>
        <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <b-form-input v-model="filter" placeholder="Search" />
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </div>
          </div>
        </b-col>
         <b-col order="2" order-md="5" cols="4" sm="6" md="2" lg="2" class="ml-auto my-1">
          <b-button v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" class="pull-right" variant="primary" @click="showNewHaulModal()">Add Haul</b-button>
        </b-col>
      </b-row> 

      <b-row>
        <b-col v-if="role =='super_admin' || role =='trucking_company_admin' || role === 'trucking_operational_manager'" class="my-1" title="Invoices" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.invoice_name" >
            <b-dropdown-item @click="inFilter('Hauls Without Invoice', 0)">Hauls Without Invoice</b-dropdown-item>
            <b-dropdown-item @click="inFilter('Hauls With Invoice', 1)">Hauls With Invoice</b-dropdown-item>           
          </b-dropdown>
        </b-col>
        <b-col v-if="filter_by.invoice_id == 1 && role =='super_admin' || role =='trucking_company_admin' || role === 'trucking_operational_manager'" class="my-1" title="Invoices" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.invoic_name" >
            <b-dropdown-item @click="ivFilter('All Invoices', 0)">All Invoices</b-dropdown-item>  
             <b-dropdown-item v-for="invoice_filter in invoices_filter" @click="ivFilter(invoice_filter.invoice_ref, invoice_filter.id)">{{invoice_filter.invoice_ref}}</b-dropdown-item>      
          </b-dropdown>
        </b-col>
        <b-col v-if="role =='super_admin' || role =='trucking_company_admin' || role === 'trucking_operational_manager'" class="my-1" title="Energy Companies" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.energy_company_name" >
            <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
            <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col v-if="role !=='trucking_company_admin' || role !== 'trucking_operational_manager'" class="my-1 f4" title="Trucking Companies" sm="6" md="3" lg="2">
            <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.trucking_company_name">
              <b-dropdown-item @click="tcFilter('All Trucking Companies', 0)"><h6>All Trucking Companies</h6></b-dropdown-item>
              <b-dropdown-item v-for="trucking_company_filter in trucking_companies_filter" @click="tcFilter(trucking_company_filter.name, trucking_company_filter.id)">{{trucking_company_filter.name}}</b-dropdown-item>
            </b-dropdown>
        </b-col>
        <b-col class="my-1 f6" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop" :text="filters_save.load_name" title="Load Locations">
            <b-dropdown-item @click="lFilter('All Loads', 0)">All Loads</b-dropdown-item>
            <b-dropdown-item v-for="load_location_filter in load_locations_filter" @click="lFilter(load_location_filter.legal_location, load_location_filter.id)">{{load_location_filter.legal_location}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f7" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.unload_name" title="Unload Locations">
            <b-dropdown-item @click="uFilter('All Unloads', 0)">All Unloads</b-dropdown-item>
            <b-dropdown-item v-for="unload_location_filter in unload_locations_filter" @click="uFilter(unload_location_filter.legal_location, unload_location_filter.id)">{{unload_location_filter.legal_location}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" class="my-1 f8" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" right @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="Approved" title="Approved">
            <b-dropdown-item @click="approvedFilter('All')">All</b-dropdown-item>
            <b-dropdown-item @click="approvedFilter('Approved')">Approved</b-dropdown-item>
            <b-dropdown-item @click="approvedFilter('Unapproved')">Unapproved</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f9" title="Initial Date" sm="6" md="4" lg="3">
          <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
        </b-col>
        <b-col class="my-1 lg-3 f10" title="End date" sm="6" md="4" lg="3">
          <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
        </b-col>       
        <b-col class="my-1 lg-3 f11 " style=" padding-top: 3px; padding-bottom: 3px;" sm="6" md="4" lg="3">
          <b-button block style="height: 100%;" @click="clearFilters()">Clear</b-button>
        </b-col> 
      </b-row>

      <b-row>
        <b-col v-if="haul_ids.length > 0 && filters_save.invoice_name == 'Hauls Without Invoice'" class="my-1">
          <div class="card bulk-action-controls m-0">
            <div class="card-body p-1 d-flex align-middle">
              <p class="col-sm-3 ml-2 px-0 my-auto align-middle"> {{haul_ids.length}} haul(s) selected of {{totalRows}}</p>
             <!-- <b-button v-if="!allSelected" class="col-sm-2 ml-0 btn-select" @click="selectAllHauls"> Select All </b-button>-->
              <b-dropdown id="ddown1" text="Bulk Actions" class="mx-2 my-auto align-middle" title="Bulk Actions">
                <b-dropdown-item @click="openModal()">Add to Invoice</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager' || role =='super_admin'" @click="h_approved_click()">Approve Haul</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager' || role =='super_admin'" @click="h_deapproved_click()">Unapprove Haul</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager' || role =='super_admin'" @click="h_unasigned_click()">Unassign Haul from All Invoices</b-dropdown-item>
              </b-dropdown>
              <span class="align-middle ml-auto close-controls"></span>
            </div>
          </div>
        </b-col>
      </b-row> 

      <b-row>
        <b-col v-if="haul_ids.length > 0 && filters_save.invoice_name == 'Hauls With Invoice'" class="my-1" >
          <div class="card bulk-action-controls m-0">
            <div class="card-body p-1 d-flex align-middle">
              <p class="col-sm-3 ml-2 px-0 my-auto align-middle"> {{haul_ids.length}} haul(s) selected of {{totalRows}}</p>
             <!-- <b-button v-if="!allSelected" class="col-sm-2 ml-0 btn-select" @click="selectAllHauls"> Select All </b-button>-->
              <b-dropdown id="ddown2" text="Bulk Actions" class="mx-2 my-auto align-middle" title="Bulk Actions">
                <b-dropdown-item @click="openModal()">Re-assign to Invoice</b-dropdown-item>
                <b-dropdown-item v-if="role =='trucking_company_admin' || role =='trucking_operational_manager' || role =='super_admin'" @click="h_unasigned_click()">Unassign Haul from All Invoices</b-dropdown-item>
              </b-dropdown>
              <span class="align-middle ml-auto close-controls"></span>
            </div>
          </div>
        </b-col>
      </b-row> 
    </div>

    <!-- Main table block @row-clicked="rowClicked"-->
    <div class="card">
      <div class="card-body p-0">
        <!-- Shows when loading data-->
        <b-row v-if="loadingData">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
          </b-col>
        </b-row>
        <div v-else class="table-responsive p-0 m-0">
          <b-table 
            class="animated fadeIn" 
            ref="table"
            striped 
            bordered
            hover 
            show-empty 
            stacked="md" 
            :items="items" 
            :fields="fields" 
            :current-page="currentPage" 
            :per-page="perPage" 
            @filtered="onFiltered" 
            :filter="filter" 
            @row-clicked="rowClicked"        
          >

          <template slot="action" slot-scope="row">   
          </template> 
            <template slot="HEAD_select_haul" slot-scope="data">
              <b-form-checkbox
                id="checkbox"
                @click.native.stop
                v-model="allSelected" 
                @change="toggleAllSelected"
              ></b-form-checkbox>
            </template>
            <template slot="select_haul" slot-scope="item">
              <b-form-checkbox id="checkbox" @click.native.stop  :key="item.index" :value="item.item.haul_id" v-model="haul_ids">
              </b-form-checkbox>
            </template>

            <template slot="invoiced_cost" slot-scope="item">
              <span v-if="item.item.invoiced_cost!=item.item.total_cost " style="color:red">{{item.item.invoiced_cost}}</span>
              <span v-else>{{item.item.invoiced_cost}}</span>
            </template>
          </b-table> 
        </div>
        <!-- User Interface controls -->
        <div class="table-controls">
          <b-row>
            <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
              <div class="input-group mb-3">
                <div class="input-group-prepend"> </div>
                <b-select :options="pageOptions" v-model="perPage" />
              </div>
            </b-col>
            <b-col lg="10" md="10" sm="12" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
            </b-col>
          </b-row>
        </div>
        <!-- End User Interface controls-->
      </div>
    </div>

     <b-modal title="Add to Invoice" v-model="modalInvoice" ok-variant="primary" hide-header-close no-close-on-backdrop no-close-on-esc>

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="12">
            <b-form-group  :label-cols="2" id="L4"  label-for="folderID" horizontal>
              <b-form-radio-group class="custom-checkboxes" :options="invoiceOptions" name="Checkboxes" plain v-model="selected"></b-form-radio-group>
              </b-form-group>
          </b-col>
        </b-row>
      </b-container> 

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="modalInvoice=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="addHaulsInvoice()">
          Save
        </b-btn>
      </div>

    </b-modal> 
    <!-- Configure Columns to Display-->
     <b-modal title="Columns to Display" v-model="configTable" ok-variant="primary">

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
                            <b-form-checkbox :disabled="shouldBeDisabled('ticket')" value="ticket" @change="actionField('ticket', 'Ticket #',1)">Ticket #</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_id')" value="haul_id" @change="actionField('haul_id', 'Haul ID', 2)">Haul Id</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('full_name')" value="full_name" @change="actionField('full_name', 'Driver', 5)">Driver</b-form-checkbox>
              <b-form-checkbox v-if="role =='super_admin' || role =='trucking_company_admin' || role =='operations_manager' || role =='trucking_operational_manager'" :disabled="shouldBeDisabled('energy_company')" value="energy_company" @change="actionField('energy_company', 'Energy Company', 3)">Energy Company</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('load_location')" value="load_location" @change="actionField('load_location', 'Load', 6)">Load</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('unload_location')" value="unload_location" @change="actionField('unload_location', 'Unload', 7)">Unload</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('truck')" value="truck" @change="actionField('truck','Trailer',8)">Trailer</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('volume_actual')" value="volume_actual" @change="actionField('volume_actual','Deliveries',9)">Deliveries</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('oil_actual')" value="oil_actual" @change="actionField('oil_actual','Oil',10)">Oil</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('water_actual')" value="water_actual" @change="actionField('water_actual', 'Water',11)">Water</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('bsw')" value="bsw" @change="actionField('bsw', 'BS&W', 12)">BS&W</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_start_date')" value="haul_start_date" @change="actionField('haul_start_date', 'Start Date', 13)">Start Date</b-form-checkbox>

              <b-form-checkbox :disabled="shouldBeDisabled('haul_end_date')" value="haul_end_date" @change="actionField('haul_end_date', 'End Date', 14)">End Date</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('duration')" value="duration" @change="actionField('duration', 'Duration',9)">Duration</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('rate')" value="rate" @change="actionField('rate','Rate', 10)">Rate</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('stb')" value="stb" @change="actionField('stb', 'STB', 11)">STB</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('fluid_type')" value="fluid_type" @change="actionField('fluid_type','Fluid Type', 15)">Fluid Type</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('stb_rate')" value="stb_rate" @change="actionField('stb_rate','STB Rate', 12)">STB Rate</b-form-checkbox> -->
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('unit_cost')" value="unit_cost" @change="actionField('unit_cost','Unit Cost',13)">Unit Cost</b-form-checkbox> -->
              
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('total_distance')" value="total_distance" @change="actionField('total_distance','Distance', 15)">Distance</b-form-checkbox> -->

             <!-- <b-form-checkbox :disabled="shouldBeDisabled('total')" value="total" @change="actionField('total','Total', 16)">Total</b-form-checkbox> -->
              <b-form-checkbox :disabled="shouldBeDisabled('trucking_company')" value="trucking_company" @change="actionField('trucking_company','Trucking Company', 4)">Trucking Company</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('water_percentage_actual')" value="water_percentage_actual" @change="actionField('water_percentage_actual','Water Cut Actual', 16)">Water Cut Actual</b-form-checkbox>
               <!--<b-form-checkbox :disabled="shouldBeDisabled('water_cut_estimate')" value="water_cut_estimate" @change="actionField('water_cut_estimate','Water Cut Estimate', 19)">Water Cut Estimate</b-form-checkbox> -->

              <b-form-checkbox :disabled="shouldBeDisabled('haul_start_time')" value="haul_start_time" @change="actionField('haul_start_time','Start Time', 17)">Start Time</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('haul_end_time')" value="haul_end_time" @change="actionField('haul_end_time','End Time', 18)">End Time</b-form-checkbox>
              <!-- <b-form-checkbox :disabled="shouldBeDisabled('driving_time')" value="driving_time" @change="actionField('driving_time','Driving Time', 22)">Driving Time</b-form-checkbox> -->

              <b-form-checkbox :disabled="shouldBeDisabled('avg_speed')" value="avg_speed" @change="actionField('avg_speed','Speed Avg', 19)">Speed Avg</b-form-checkbox>

            </b-form-checkbox-group>
          </b-col>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">


              <b-form-checkbox :disabled="shouldBeDisabled('cost_regular')" value="cost_regular" @change="actionField('cost_regular','Regular Cost', 20)">Regular Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('cost_stb')" value="cost_stb" @change="actionField('cost_stb','STB Cost', 21)">STB Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('cost_worktime')" value="cost_worktime" @change="actionField('cost_worktime','Worktime Cost', 22)">Worktime Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('total_cost')" value="total_cost" @change="actionField('total_cost','Total Cost', 23)">Total Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('invoiced_cost')" value="invoiced_cost" @change="actionField('invoiced_cost','Invoice Cost', 24)">Invoice Cost</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('justification')" value="justification" @change="actionField('justification','Justification', 25)">Justification</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('flags')" value="flags" @change="actionField('flags','Flags', 26)">Flags</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('invoice_id')" value="invoice_id" @change="actionField('invoice_id','Invoice ID', 27)">Invoice ID</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('invoice_ref')" value="invoice_ref" @change="actionField('invoice_ref','Invoice Ref', 28)">Invoice Ref</b-form-checkbox>
              <b-form-checkbox v-if="role =='super_admin' || role =='trucking_company_admin' || role =='trucking_operational_manager'" :disabled="shouldBeDisabled('approved/unapproved')" value="approved/unapproved" @change="actionField('approved/unapproved','Approved/Unapproved Haul', 29)">Approved/Unapproved Haul</b-form-checkbox>
    
              <b-form-checkbox :disabled="shouldBeDisabled('truck_unit')" value="truck_unit" @change="actionField('truck_unit','Truck Unit',30)">Truck Unit</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('terminal_boss')" value="terminal_boss" @change="actionField('terminal_boss', 'Terminal Boss Ticket',31)">Terminal Boss Ticket</b-form-checkbox>
              <b-form-checkbox :disabled="shouldBeDisabled('volume_estimate')" value="volume_estimate" @change="actionField('volume_estimate','Volume Estimate',32)">Volume Estimate</b-form-checkbox>
					    <b-form-checkbox :disabled="shouldBeDisabled('rate')" value="rate" @change="actionField('rate','Rate', 33)">Rate</b-form-checkbox> 			  
					    <b-form-checkbox :disabled="shouldBeDisabled('stb')" value="stb" @change="actionField('stb', 'STB Time', 34)">STB Time</b-form-checkbox>		  
					    
              <b-form-checkbox :disabled="shouldBeDisabled('fluid_subtotal_cost')" value="fluid_subtotal_cost" @change="actionField('fluid_subtotal_cost','Fluid Subtotal Cost', 35)">Fluid Subtotal Cost</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('fluid_gst')" value="fluid_gst" @change="actionField('fluid_gst','Fluid GST', 36)">Fluid GST</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('fluid_gst_subtotal')" value="fluid_gst_subtotal" @change="actionField('fluid_gst_subtotal','Fluid Total', 37)">Fluid Total</b-form-checkbox> 

					    <b-form-checkbox :disabled="shouldBeDisabled('wait_time_cost_subtotal')" value="wait_time_cost_subtotal" @change="actionField('wait_time_cost_subtotal','Wait Time Cost Subtotal', 38)">Wait Time Cost Subtotal</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('wait_time_gst')" value="wait_time_gst" @change="actionField('wait_time_gst','Wait Time GST', 39)">Wait Time GST</b-form-checkbox>                                 
					    <b-form-checkbox :disabled="shouldBeDisabled('wait_time_gst_subtotal')" value="wait_time_gst_subtotal" @change="actionField('wait_time_gst_subtotal','Wait Time GST Subtotal', 40)">Wait Time GST Subtotal</b-form-checkbox> 
            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-container>
      <!-- </b-form-checkbox-group> -->

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="configTable=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="saveSelectedColumns()">
          Save
        </b-btn>
      </div>

    </b-modal>
        <!-- New Invoice Notification Modal -->
    <b-modal class="newHaulModal" ref="newModal" title="Invoice Notification" v-model="newModal" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <b-form-group v-if="role =='super_admin'" :label-cols="4" horizontal label="Trucking Company" label-for="trucking_company">
              <b-form-select :disabled="company_name.length==0" value-field="id" text-field="trucking_company_name" id="trucking_company" v-model="model.trucking_company_id" :options="company_name" @input="selects_trucking_company_1()"> 
                <template slot="first"><option :value="null" disabled>-- select trucking company --</option></template>
          </b-form-select>
          </b-form-group>
          <b-form-group  :label-cols="4" horizontal label="Energy Company" label-for="energy_company">
            <b-form-select :disabled="energy_companies.length==0" value-field="id" text-field="energy_company_name" id="energy_company" v-model="model.energy_company_id" :options="energy_companies">
              <template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
            </b-form-select>
          </b-form-group> 
          <b-form-group  :label-cols="4" horizontal label="Invoice Ref" label-for="inv0">
            <b-form-select :disabled="invoices_filter.length==0" value-field="id" text-field="invoice_ref" id="inv0" v-model="model.invoice_id" :options="invoices_filter">
              <template slot="first"><option :value="null" disabled>-- select invoice ref --</option></template>
            </b-form-select>
          </b-form-group>		
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="sendbtn" size="md" variant="primary" @click="send_click()" class="float-right">Send</b-btn>
      </div>
    </b-modal> 

        <!-- New Haul Modal-->
    <b-modal class="newHaulModal" ref="newHaulModal" title="New Haul" v-model="newEC" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col cols="12">
          <b-form-group v-if="role ==='super_admin'" :label-cols="4" horizontal label="Truking Company" label-for="truck_company">
            <b-form-select id="truck_company_id" v-model="newHaul.truck_company_id" :options="newHaul.truck_company_select" @input="selects_trucking_company()" />
          </b-form-group>

          <b-form-group :label-cols="4" horizontal label="Trailer" label-for="truck">
            <b-form-select :disabled="newHaul.truck_select.length==0" id="truck_id" v-model="newHaul.truck_id" :options="newHaul.truck_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Truck Unit" label-for="truck_unit">
            <b-form-select :disabled="newHaul.truck_unit_select.length==0" id="truck_unit" v-model="newHaul.truck_unit_id" :options="newHaul.truck_unit_select" />
          </b-form-group>

          <b-form-group :label-cols="4" horizontal label="Driver" label-for="full_name">
            <b-form-select :disabled="newHaul.driver_select.length==0" id="user_id" v-model="newHaul.user_id" :options="newHaul.driver_select" @input="selects_driver()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Energy Company" label-for="energy_company">
            <b-form-select :disabled="newHaul.energy_company_select.length==0" id="energy_companies_id" v-model="newHaul.energy_companies_id" :options="newHaul.energy_company_select" @input="selects_energy_company()" />
          </b-form-group>

          <b-form-group :label-cols="4" horizontal label="Load" label-for="load_location">
            <b-form-select :disabled="newHaul.load_location_select.length==0" id="load_location_id" v-model="newHaul.load_location_id" :options="newHaul.load_location_select" @input="selects_load_location()" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Fluid" label-for="fluid_type">
            <b-form-select :disabled="newHaul.fluid_type_select.length==0" id="fluid_type_id" v-model="newHaul.fluid_type_id" :options="newHaul.fluid_type_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Unload" label-for="unload_location">
            <b-form-select :disabled="newHaul.unload_location_select.length==0" id="unload_location_id" v-model="newHaul.unload_location_id" :options="newHaul.unload_location_select" />
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Water Cut Actual %" label-for="water_percentage_actual">
            <b-form-input id="water_percentage_actual" placeholder="0.00" v-model="newHaul.water_percentage_actual" type="text" @blur.native="inputBlur('water_percentage_actual')" @keydown.native="myOnlyNumber($event, 'water_percentage_actual')"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Volume Actual" label-for="volume_actual">
            <b-form-input id="volume_actual" placeholder="0.00" v-model="newHaul.volume_actual" @keydown.native="myOnlyNumber($event, 'volume_actual')" @blur.native="inputBlur('volume_actual')" type="text"></b-form-input>
          </b-form-group>

          <b-form-group :label-cols="4" horizontal label="Volume Estimate" label-for="volume_estimate">
            <b-form-input id="volume_estimate" placeholder="0.00" v-model="newHaul.volume_estimate" @keydown.native="myOnlyNumber($event, 'volume_estimate')" @blur.native="inputBlur('volume_estimate')" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="# Ticket" label-for="ticket">
            <b-form-input id="ticket" v-model="newHaul.ticket"  type="text" @keydown.native=keyMonitor($event) autocomplete="off" placeholder="max 10 characters"></b-form-input>
          </b-form-group>

          <b-form-group :label-cols="4" horizontal label="Terminal Ticket" label-for="t_ticket">
            <b-form-input id="t_ticket" v-model="newHaul.t_ticket"  type="text" @keydown.native=keyMonitor1($event) autocomplete="off" placeholder="max 10 characters"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Terminal Boss Number" label-for="t_boss">
            <b-form-input id="t_boss" v-model="newHaul.t_boss"  type="text" v-mask="'##########'" autocomplete="off" placeholder="max 10 digits"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Chain Up" label-for="chain_up">
            <b-form-select  id="chain_up" v-model="newHaul.chain_up"><option :value='false'>NO</option><option :value='true'>YES</option></b-form-select>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Start Date" label-for="haul_start_date">
            <b-form-input id="haul_start_datetime" v-model="newHaul.haul_start_datetime" type="date" ></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Start Time" label-for="haul_start_time">
            <b-form-input id="haul_start_time" placeholder="hh:mm" v-mask="'##:##'" @blur.native="timeBlur('haul_start_time')" v-model="newHaul.haul_start_time" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="End Date" label-for="haul_start_date">
            <b-form-input id="haul_end_datetime" v-model="newHaul.haul_end_datetime" type="date"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="End Time" label-for="haul_end_time">
            <b-form-input id="haul_end_time" placeholder="hh:mm" v-mask="'##:##'" @blur.native="timeBlur('haul_end_time')" v-model="newHaul.haul_end_time" type="text"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="4" horizontal label="Comments Start" label-for="comments_start">
            <b-form-input id="comments_start" v-model="newHaul.comments_start" type="text"></b-form-input>
          </b-form-group>
          <b-form-group v-for="(wait_time, index) in newHaul.wait_times" :key="wait_time.type_id" :label-cols="4" horizontal :label="waitTimeLabel(wait_time)" :label-for="waitTimeLabel(wait_time)">
            <b-form-input placeholder="hh:mm" v-mask="'##:##'" v-model="wait_time.time" type="text"></b-form-input>
           
            <b-form-input placeholder="Comments" v-model="wait_time.comments" type="text"></b-form-input>
            <b-btn v-if="wait_time.type_id == 5" size="md" variant="secondary" @click="removeTimeBlur(index)" class="wait-time-remove-button">X</b-btn>
          </b-form-group>

          <b-btn size="md" variant="primary" @click="addWaitTime" class="float-right">Add another Wait Time</b-btn>

        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewHaulModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="saveHaul" class="float-right">Save</b-btn>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import invoices_service from './invoices_service'
  import haul_service from '../hauls/haul_service'
  import moment from 'moment';
  import users_service from '../users/users_service'

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'HaulsInvoices',
    created: function() {
      this.$root.$on('haul_Updated', () => {
        this.getAll()
      });
      this.getAll()
    },
    data() {
      return {
        allSelected                 : false,
        tableValues                 : [],
        status                      :'unchecked',
        haul_ids                    : [],
        haul_iidds                  : [],
        haul_iiddss                 : [],
        selected                    : '',
        row                         : 0,
        loadingData                 : true,
        companyName                 : '',
        companyId                   : null,
        configTable                 : false,

        items                       : items,
        itemsAll                    : items,
        totalRows                   : items.length,
        v_items                     :null,
        fieldsSelected              : 8,
        maxFieldsSelected           : 24,
        tempFields                  : [],
        fields: [
        {
          key: 'select_haul',
          label: 'Select',
          thClass: 'select_column', tdClass: 'select_column'
        }, 
        {
          key: 'ticket',
          label: 'Ticket #',
          sortable: true
        },
        {
          key: 'invoice_id',
          label: 'Invoice ID',
          sortable: true
        }, 
        {
          key: 'invoice_ref',
          label: 'Invoice Ref',
          sortable: true
        }, 
        {
          key: 'energy_company',
          label: 'Energy Company',
          sortable: true
        }, 
        {
          key: 'trucking_company',
          label: 'Trucking Company',
          sortable: true
        }, 
        {
          key: 'unload_location',
          label: 'Unload',
          sortable: false,
        }, 
        {
          key: 'load_location',
          label: 'Load',
          sortable: false,
        }, 
        {
          key: 'volume_actual',
          label: 'Deliveries',
          sortable: true,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(parseFloat(value).toFixed(2)*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
        },
        {
          key: 'bsw',
          label: 'BS&W (%)',
          sortable: false,
          formatter: (value) => { return  parseFloat(value).toFixed(2) }
        }, 
        {
          key: 'oil_actual',
          label: 'Oil',
          sortable: false,
          formatter: (value) => { if (this.bbll==true){ 
                                    value = Number(parseFloat(value).toFixed(2)*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value.toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  } return value }
           //formatter: (value) => { console.log(parseFloat(value).toFixed(2)) ; return  parseFloat(value).toFixed(2) } //Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+ ' m³'}
        },
        {
          key: 'water_actual',
          label: 'Water',
          sortable: false,
          formatter: (value) => { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }  
        },
        {
          key: 'haul_start_date',
          label: 'Start Date',
          sortable: true,
          formatter:(value) => { return moment(value).format("MMM DD, YYYY") }
        }
        ],
        currentPage               : 1,
        perPage                   : 25,

        pageOptions               : [25, 50, 100],
        filter                    : null,
        modalInfo                 : {
          title: '',
          content: ''
        },
        modalEdit                 : {
          title: ''
        },
        selectedItems             : [
          'energy_company',          
          'trucking_company',
          'unload_location',
          'ticket',
          'load_location',
          'volume_actual',
          'bsw',
          'oil_actual',
          'water_actual',
          'haul_start_date',
          'invoice_id',
          'invoice_ref',
        ],
				role                      :'',
				savebtn                   :true,
				energy_company_id         :null,
        unit                      :'',
        fromHaul                  :0,
        bbll                      :false,
        myToggle                  :false,
        filter_by:{"initial_date": moment().startOf('week').format('YYYY-MM-DD'), "end_date": moment().endOf('week').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column":[
          'ticket',
          'energy_company',          
          'trucking_company',
          'unload_location',        
          'load_location',
          'volume_actual',
          'bsw',
          'oil_actual',
          'water_actual',
          'haul_start_date',
        ], "invoice_id":"",
          "invoic_id":"",
        },
        energy_companies_filter     : '',
        //folders                     : '',
        load_locations_filter       : '',
        unload_locations_filter     : '',
        drivers_filter              : '            ',
        trucks_filter               :'',
        trucking_companies_filter   :'',
        invoices_filter             :[],
        //fluid_types_filter          :'',
        filters_save              : {
          //folder_id               : 0,
          //folder                  : 'All Folders',
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          //fluid_type_id           : 0,
          //fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All Unloads',
          initial_date            : '',
          end_date                : '',
          invoice_id              : 0,
          invoice_name            : 'Hauls Without Invoice',
          invoic_id               : 0,
          invoic_name             : 'All Invoices',
          //flag_name               : 'All Flags',
          //sortby                  : 'haul_id',
          //sortdesc                : false
        },
        // export to csv
        filename : 'hauls_discrenpacy_'+moment().format('YYYYMMDDHHMM')+'.csv',        
        json_fields: {
          "haul_id"             :"haul_id",
          "energy_company"      :"energy_company",
          "trucking_company"    :"trucking_company",
          "ticket"              :"ticket",
          "unload_location"     :"unload_location", 
          "load_location"       :"load_location",       
          "volume_actual"       :"volume_actual",  
          "bsw"                 :"bsw",      
          "oil_actual"          :"oil_actual",  
          "energy_company_unload"      :"energy_company_unload",
          "unload_location_unload"     :"unload_location_unload",
          "volume_actual_unload"       :"volume_actual_unload",  
          "bsw_unload"                 :"bsw_unload",      
          "oil_unload"          :"oil_unload",        
       },
       items_csv      : [],
       modalInvoice   : false,
       invoiceOptions : [],
       invoiceHauls   : [],
       newModal       : false,
        model: {
            id                  : null,
            energy_company_id   : null, 
            trucking_company_id : null, 
            invoice_id          : null,
        },
        company_name    : [],
        energy_companies: [],
        sendbtn         :true,
        newHaul: {
          water_actual              : "",
          water_percentage_estimate : "",
          oil_actual                : "",
          volume_estimate           : "",
          truck_company_select      : [],
          driver_select             : [],
          energy_company_select     : [],
          unload_location_select    : [],
          fluid_type_select         : [],
          load_location_select      : [],
          loads_locations           : [],
          truck_select              : [],
          truck_unit_select         : [],

          companyName               : '',
          load_location             : '',
          loadingData               : true,
          unload_location           : '',
          haul_start_date           : '',

          truck_company_id          : '',
          load_location_id          : '',
          user_id                   : '',
          full_name                 : '',
          truck_id                  : '',
          truck_unit_id             : '',
          trucking_company_id       : '',
          energy_companies_id       : '',
          unload_location_id        : '',
          fluid_type_id             : '',
          water_percentage_actual   : '',
          water_percentage_estimate : '',
          volume_actual             : '',
          volume_estimate           : '',

          haul_end_datetime         : '',
          haul_start_datetime       : '',
          haul_end_time             : '',
          haul_start_time           : '',
          chain_up                  : false,

          comments_start            : '',
          comments_end              : '',
          wait_times_csv            : [],
          wait_times                : [{
            "type_id": "3",
            "time": "00:00",
            "comments": ""
          },
          {
            "type_id": "4",
            "time": "00:00",
            "comments": ""
          },
          ],
          ticket                    : '',
          t_ticket                  : '',
          t_boss                    : '',
        },
        newEC         : false,
        insert_data   : { 'trucking_companies':[]},
        haul_updated  : false,
        allSelected   : false,
        Approved      : 'Show Approved',
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      selectAllHauls() {
        if (!this.allSelected) {
          this.toggleAllSelected();
        }
      },
      unselectAllHauls() {
        if (this.haul_ids.length>0 ) {
          //if (!this.h_approved) {
              this.haul_ids = []
          //} else {
              let tmp1 = this.tableValues.map(item => {
                   return item.haul_id})
              let tmp = this.haul_ids
              let tmp2 = this.array_diff(tmp, tmp1) 
              this.haul_ids = tmp2
          //}
        }
      },
      toggleAllSelected() {
        this.allSelected = !this.allSelected
        if (this.allSelected) {
          //if (!this.h_approved) {
            this.haul_ids = []
            this.haul_ids = this.items.map(item => {
                   return item.haul_id})
         // } else {
          //  let tmp = this.tableValues.map(item => {
           //        return item.haul_id})
           // let tmp1 = this.haul_ids
          //  tmp1.push.apply(tmp1,tmp)
          //  this.haul_ids = [...new Set(tmp1)]
          //}
        }
        else {
          //if (!this.h_approved) {
              this.haul_ids = []
          //} else {
          //    let tmp1 = this.tableValues.map(item => {
          //         return item.haul_id})
           //   let tmp = this.haul_ids
           //   let tmp2 = this.array_diff(tmp, tmp1) 
            //  this.haul_ids = tmp2
          //}
        }
      },
      array_diff(tmp, tmp1) {
	      return tmp.filter(elemento => tmp1.indexOf(elemento) == -1)
      }, 

      checkedField(row) {
        if (this.haul_ids.includes(row.item.haul_id) ) {
          let index = this.haul_ids.indexOf(row.item.haul_id);
           if (index > -1) {
             this.haul_ids.splice(index, 1);
           }
        }else{
          this.haul_ids.push(row.item.haul_id)

        }
      },
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
      },
      openSelectColumns() {
        this.tempFields = [...this.fields]
        this.configTable = true
      },
      saveSelectedColumns() {
        this.fields = [...this.tempFields]
        this.configTable = false
        this.filter_by.column = this.fields.map(item =>  item.key )
        haul_service.saveSelectedColumns(this.fields)
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.getAll()
                }
              }) 
        })
      },
      shouldBeDisabled(option) {
        return (this.fieldsSelected >= this.maxFieldsSelected) && this.tempFields.map(o => o.key).indexOf(option) == -1
      },
      actionField(option, label, position) {

        var fieldsLength = this.tempFields.length
        var fieldIsActive = false
        for (var i = 0; i <= fieldsLength; i++) {
          fieldIsActive = true
          try {
            if (this.tempFields[i].key === option || this.tempFields[i] === option) {
              this.tempFields.splice(i, 1)
              fieldIsActive = false
              break
            }
          } catch (err) {

            if (option=='haul_start_date' || option=='haul_end_date') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
              }
            } else if (option=='oil_actual' || option=='volume_actual' || option=='water_actual'|| option=='volume_estimate') {
                      option = {
                        key: option,
                        label: label,
                        sortable: true,
                        formatter: (value) =>  { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
                      }
            } else {
                option = {
                  key: option,
                  label: label,
                  sortable: true
                }
            }
            this.tempFields.splice(position, 0, option)
          }
        }
        this.fieldsSelected = this.tempFields.length
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      getAll() {
        this.items = []
        //this.v_items = []
        invoices_service.get_invoices_hauls(this.filter_by)
          .then(data => {
            if (data.status == 'success') {
              this.items            = data.hauls    //.filter(o => o.status_id == (this.trash ? 2 : 1))
              this.invoices_filter  = data.invoice_filter
              this.items_csv        = this.items 
              this.itemsAll         = this.items
              if (this.Approved==='Approved' || this.Approved==='Unapproved') {
                this.approvedFilter(this.Approved)
              }
              //console.log(this.items)
              this.role= data.role
              this.company_name     = data.trucking_companies
              if (this.role === 'trucking_company_admin' || this.role === 'trucking_operational_manager') {                      
                      this.model.energy_company_id  = null
                      let trucking_companies        =  this.company_name
                      if (trucking_companies.length > 0) {
                        this.model.trucking_company_id  = trucking_companies[0].id
                        this.energy_companies           = trucking_companies[0].energy_companies
                      } else {
                          this.model.trucking_company_id= null
                          this.energy_companies         = []
                      }
              }  
              this.haul_ids = []
              this.allSelected   = false
              this.getAll1()
            }
            else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      getAll1() {
        haul_service.getAll1()
          .then(data => {
            if (data.status == 'success') {
              
              this.energy_companies_filter  = data.energy_companies_filter
              //this.folders                  = data.folders
              //this.drivers_filter           = data.drivers_filter
              this.load_locations_filter    = data.load_locations_filter
              this.unload_locations_filter  = data.unload_locations_filter
              //this.trucks_filter            = data.trucks_filter
              //this.truck_types_filter       = data.truck_types_filter
              this.trucking_companies_filter = data.trucking_companies_filter
              //this.fluid_types_filter       = data.fluid_types_filter 
              this.bbll       = data.bbl
              //this.role       = data.role
              if (this.role=='operations_manager') {
         this.fields=  [
        {
          key: 'haul_id',
          label: 'ID',
          sortable: false
        },  
       // {
        //  key: 'trucking_company',
         // label: 'Trucking Company',
        //}, 
        {
          key: 'unload_location',
          label: 'Unload',
          sortable: false,
        }, 
        {
          key: 'ticket',
          label: 'Ticket #',
          sortable: false
        },
        {
          key: 'load_location',
          label: 'Load',
          sortable: false,
        }, 
        {
          key: 'volume_actual',
          label: 'Deliveries',
          sortable: true,
          //formatter: (value) => { if (this.bbll==true){
            //                        value = Number(parseFloat(value).toFixed(2)*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
             //                     } else {
              //                      value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                //                  }; return value }
        },
        {
          key: 'bsw',
          label: 'BS&W (%)',
          sortable: false,
        }, 
        {
          key: 'oil_actual',
          label: 'Oil',
          sortable: false,
          //formatter: (value) => { if (this.bbll==true){
            //
           //                         value = Number(parseFloat(value).toFixed(2)*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
            //                      } else {
             //                       value = Number(value.toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
              //                    } return value }
           //formatter: (value) => { console.log(parseFloat(value).toFixed(2)) ; return  parseFloat(value).toFixed(2) } //Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+ ' m³'}
        }, 
        {
          key: 'drivers_filter',
          label: '            ',
        },
        { key: 'unload_location_unload',label: 'Unload',sortable: false,
        }, 
        { key: 'volume_actual_unload', label: 'Total Volume at Unload',sortable: true,
        },
        { key: 'bsw_unload', label: 'BS&W at Unload',sortable: false,
        },
        { key: 'oil_unload', label: 'Oil at Unload',sortable: false,
        },
        { key: 'action',label: 'Action'}
        ]             
              }

            }
            else {

              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      reformat(value) {
        if (value.indexOf('%')!= -1) {
            return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" %"
        } else if (value.indexOf('km')!= -1) {
            return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" km"
        } else {
            return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        }
      },
      ecFilter(ec_filter,id) {
        this.filter_by['energy_companies_id'] = id

        if (id==0) {
          this.filter_by['energy_companies_id'] = ''
        }
        this.filters_save.energy_company_name =  ec_filter
        this.filters_save.energy_companies_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true

      },
      dFilter(d_filter,id) {
        this.filter_by['users_id'] = id
        if (id==0) {
          this.filter_by['users_id'] = ''
        }
        this.filters_save.driver_name =  d_filter
        this.filters_save.users_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      tcFilter(tc_filter,id) {
        this.filter_by['trucking_company_id'] = id
        if (id==0) {
          this.filter_by['trucking_company_id'] = ''
        }
        this.filters_save.trucking_company_name =  tc_filter
        this.filters_save.trucking_company_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      lFilter(l_filter,id) {
        this.filter_by['load_location_id'] = id
        if (id==0) {
          this.filter_by['load_location_id'] = ''
        }
        this.filters_save.load_name =  l_filter
        this.filters_save.load_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      uFilter(u_filter,id) {
        this.filter_by['unload_location_id'] = id
        if (id==0) {
          this.filter_by['unload_location_id'] = ''
        }
        this.filters_save.unload_name =  u_filter
        this.filters_save.unload_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      iFilter(a) {
        if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
          this.filters_save.end_date = ''
        }
        this.filter_by.initial_date = a
        this.filters_save.initial_date = this.filter_by.initial_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      eFilter(a) {
        if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
          this.filters_save.initial_date = ''
        }
        this.filter_by.end_date = a
        this.filters_save.end_date = this.filter_by.end_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      tFilter(t_filter,id) {
        this.filter_by['truck_id'] = id
        if (id==0) {
          this.filter_by['truck_id'] = ''
        }
        this.filters_save.truck_name =  t_filter
        this.filters_save.truck_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      inFilter(t_filter,id) {
        this.filter_by['invoice_id'] = id
        if (id==0) {
          this.filter_by['invoice_id'] = ''
        }
        this.filters_save.invoice_name =  t_filter
        this.filters_save.invoice_id   = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      ivFilter(t_filter,id) {
        this.filter_by['invoic_id'] = id
        if (id==0) {
          this.filter_by['invoic_id'] = ''
        }
        this.filters_save.invoic_name =  t_filter
        this.filters_save.invoic_id   = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      clearFilters() {
        this.filter_by = {"initial_date": moment().startOf('week').format('YYYY-MM-DD'), 
        "end_date": moment().endOf('week').format('YYYY-MM-DD'), 
        "truck_id": "",
        "trucking_company_id":"", 
        "users_id": "", 
        "unload_location_id": "", 
        "energy_companies_id": "", 
        "load_location_id": "", 
        "column":[
          'ticket',
          'energy_company',          
          'trucking_company',
          'unload_location',
          'load_location',
          'volume_actual',
          'bsw',
          'oil_actual',
          'water_actual', 
        ], 
        "invoice_id":"",
        "invoic_id" :"",
        }
        this.filters_save = {
          energy_companies_id   : 0,
          energy_company_name   : 'All Energy Companies',
          users_id              : 0,
          driver_name           : 'All Drivers',
          trucking_company_id   : 0,
          truck_id              : 0,
          truck_name            : 'All Trucks',
          trucking_company_name : 'All Trucking Companies',
          load_location_id      : 0,
          load_name             : 'All Loads',
          unload_location_id    : 0,
          unload_name           : 'All Unloads',
          initial_date          : '', // moment().startOf('month').format('YYYY-MM-DD'),
          end_date              : '', //moment().endOf('month').format('YYYY-MM-DD'),
          flag_name             : 'All Flags',
          invoice_id            : 0,
          invoice_name          : 'Hauls Without Invoice',
          invoic_id             : 0,
          invoic_name           : 'All Invoices',          
          //sortby                : 'truck_ticket',
          //sortdesc              : false
        }
        //this.FromDash='NoWaittimes'
        this.Approved = 'Show Approved'
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      rowClicked(row, index, e) {
        e.preventDefault()
        let to_popup = {'id':row.haul_id,'haul_invoice':true,'edit':''}
        this.$root.$emit('openPopup', to_popup);
      },
      bbl() {
        users_service.bbl()
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.loadingData = true
                      this.getAll()
                }
              })
          })
      },
      form(value) {
        if (value!=='--') {
          if (this.bbll==true){
              value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
          } else {
              value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
          }; return value
      } else {
         return value
      }
      },
      form1(value) {
        if (value!=='--') {
            return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' %'
        } else {
            return value
        }
      },
      openModal() {
        this.invoiceOptions =[]
        let invoices_to_save = this.invoices_filter
        invoices_to_save.map(item => {
          var item_data          = {}
          item_data['value']     = item.id
          item_data['text']      = item.invoice_ref
          this.invoiceOptions.push(item_data)
        })
        this.modalInvoice = true

      },
      addHaulsInvoice() {

				if (!this.okToSave()) {
					return
				}
        this.invoiceHauls=[]
        this.haul_ids.map(item => {
          var item_data           = {}
          item_data['invoice_id'] = this.selected
          item_data['haul_id']    = item
          this.invoiceHauls.push(item_data)
        })
        invoices_service.addHaulsInvoice(this.invoiceHauls)
          .then((data) => {
                if (data.status == 'success') {
                    Vue.swal(data.status, data.message, data.status)
                    this.haul_ids =[]
                    this.selected =''
                    this.modalInvoice = false
                    this.getAll()
                    this.loadingData = true
                  }else{
                    this.selected =''
                    Vue.swal(data.status, data.message, data.status)
                    this.modalInvoice = false
                  }
              })
      },
      okToSave() {
					if (this.selected === undefined || this.selected === '') {
						this.$swal('Alert!', 'Invoice not selected', 'warning')
						return false
					} 
				return true
			},     
      send_notification_click() {
        this.sendbtn                    = false 
        this.model.energy_company_id    = null        
        this.model.invoice_id           = null
        this.newModal                   = true
        if (this.role ==='super_admin') {
            this.model.trucking_company_id  = null
        }
      },
      send_click() {
        if (!this.okToSend()) {
            return
        }
        let column = this.fields.map((item) => {
                            return item.key  
        })
        let send_invoice = {
          				"energy_company_id"		: this.model.energy_company_id,
									"trucking_company_id"	: this.model.trucking_company_id,
									"invoice_id"			    : this.model.invoice_id,
									"column"              : column,
				}
        invoices_service.send_invoice(send_invoice)
          .then(data => {
            if (data.status == 'success') {
              this.$swal(data.status, data.message, data.status)
            }
            else {
              this.$swal(data.status, data.message, data.status)
              return
            }
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
          })
        this.sendbtn  = true
        this.newModal = false
      },
      selects_trucking_company_1() {
          let trucking_companies                =  this.company_name
          this.energy_companies                 = []
          this.model.energy_company_id          = null
          if (trucking_companies.length > 0) {
            let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
            if (trucking_company_index > -1) {
              this.energy_companies = trucking_companies[trucking_company_index].energy_companies
            }
          }
      },
      hideNewModal() {
            this.$refs.newModal.hide()
      },
      okToSend() {
          if (this.model.trucking_company_id === undefined || this.model.trucking_company_id===null) {
              this.$swal('Alert!', 'Trucking Company not selected', 'warning')
              return false
          } else if (this.model.energy_company_id === undefined || this.model.energy_company_id===null) {
              this.$swal('Alert!', 'Energy Company not selected', 'warning')
              return false
          } else if (this.model.invoice_id === undefined || this.model.invoice_id == null) {
              this.$swal('Alert!', 'Invoice Ref not selected', 'warning')
              return false
          }   
          return true
      },
      showNewHaulModal() {
            this.savebtn                        =false
            this.newHaul.truck_company_select   = []
            this.newHaul.driver_select          = []
            this.newHaul.energy_company_select  = []
            this.newHaul.unload_location_select = []
            this.newHaul.fluid_type_select      = []
            this.newHaul.load_location_select   = []
            this.newHaul.truck_select           = []

            this.newHaul.truck_company_id = ''
            this.newHaul.load_location_id = ''
            this.newHaul.user_id          = ''
            this.newHaul.full_name        = ''
            this.newHaul.truck_id         = ''
            this.newHaul.energy_companies_id  = ''
            this.newHaul.unload_location_id   = ''
            this.newHaul.fluid_type_id        = ''

            this.newHaul.comments_start = ''
            this.newHaul.comments_end   = ''

            this.water_percentage_actual = ''
            this.water_percentage_estimate = ''
            this.volume_actual = ''
            this.volume_estimate = ''
            let tempDate = new Date()
            let tempDateTime = String(tempDate.getFullYear()) + "-" + ("0" + String(tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempDate.getDate())).slice(-2)
            let tempTime = ("0" + String(tempDate.getHours())).slice(-2) + ":" + ("0" + String(tempDate.getMinutes())).slice(-2)

            this.newHaul.haul_end_datetime = '' // tempDateTime
            this.newHaul.haul_start_datetime = '' //tempDateTime
            this.newHaul.haul_end_time = tempTime
            this.newHaul.haul_start_time = tempTime
            this.newHaul.chain_up = false
            this.newHaul.t_ticket = ''
            this.newHaul.t_boss = ''
        if (this.role =='super_admin') {
          if (this.insert_data.trucking_companies.length > 0) {  
            let trucking_companies = this.insert_data.trucking_companies
            this.newHaul.truck_company_select = trucking_companies.map((item) => {
              return {
                'value': item.id,
                'text': item.name
              }
            })
          } else {
              this.get_trucking_companies()
          }
        } else if  (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
            if (this.insert_data.trucking_companies.length > 0) {  
              this.selects_trucking_company()
            } else {
              this.get_trucking_companies()
              this.selects_trucking_company()
            } 
                        
        }
        this.newEC = true
      },
      addWaitTime() {
        this.newHaul.wait_times.push({
          "type_id": "5",
          "time": "00:00",
          "comments": ""
        })
      },
      hmsToSecondsOnly(str) {
        var p = str.split(':'),
          s = 0,
          m = 1;

        while (p.length > 0) {
          s += m * parseInt(p.pop(), 10);
          m *= 60;
        }
        s *= 60
        return s;
      },
      waitTimeLabel(wait_time) {
        let wait_times_label = [{
            type_id: "3",
            label: "Wait Time To Load"
          },
    /*      {
            type_id: "1",
            label: "Loading Time"
          },  */
          {
            type_id: "4",
            label: "Wait Time To Unload"
          },
     /*     {
            type_id: "2",
            label: "Unloading Time"
          }, */
        ]
        let myIndex = wait_times_label.map(o => o.type_id).indexOf(wait_time.type_id)
        if (myIndex > -1) {
          return wait_times_label[myIndex].label
        }
        return "Other Wait Time"
      },
      hideNewHaulModal() {
        this.$refs.newHaulModal.hide()
      },      
      okToSave_h() {
        if (this.newHaul.energy_companies_id === undefined || this.newHaul.energy_companies_id.length == 0) {
          this.$swal('Alert!', 'Energy Company not selected', 'warning')
          return false
        } else if (this.newHaul.fluid_type_id === undefined || this.newHaul.fluid_type_id.length == 0) {
          this.$swal('Alert!', 'Fluid Type not selected', 'warning')
          return false
        } else if (this.newHaul.load_location_id === undefined || this.newHaul.load_location_id.length == 0) {
          this.$swal('Alert!', 'Load Location not selected', 'warning')
          return false
        } else if (this.newHaul.truck_company_id === undefined || this.newHaul.truck_company_id.length == 0) {
          this.$swal('Alert!', 'Trucking Company not selected', 'warning')
          return false
        } else if (this.newHaul.unload_location_id === undefined || this.newHaul.unload_location_id.length == 0) {
          this.$swal('Alert!', 'Unload Location not selected', 'warning')
          return false
        } else if (this.newHaul.user_id === undefined || this.newHaul.user_id.length == 0) {
          this.$swal('Alert!', 'Driver not selected', 'warning')
          return false
        } else if (this.newHaul.truck_id === undefined || this.newHaul.truck_id.length == 0) {
          this.$swal('Alert!', 'Truck not selected', 'warning')
          return false
        } else if (this.newHaul.volume_actual === undefined || this.newHaul.volume_actual.length == 0) {
          this.$swal('Alert!', 'Volume Actual can not be empty', 'warning')
          return false
        } else if (this.newHaul.volume_actual <5) {
          this.$swal('Alert!', 'Volume Actual value must have at least five(5) ', 'warning')
          return false
  /*      } else if (this.newHaul.volume_estimate === undefined || this.newHaul.volume_estimate.length == 0) {
          this.$swal('Alert!', 'Volume Estimate can not be empty', 'warning')
          return false */
        } else if (this.newHaul.ticket === undefined || this.newHaul.ticket.length == 0) {
          this.$swal('Alert!', 'Ticket can not be empty', 'warning')
          return false
        }

        try {
          let startDateValidation = (new Date(this.newHaul.haul_start_datetime)).getFullYear()
          if(startDateValidation <= 2000 || startDateValidation >= 2100) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'Start Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        try {
          let endDateValidation = (new Date(this.newHaul.haul_end_datetime)).getFullYear()
          if(endDateValidation <= 2000 || endDateValidation >= 2100) {
            throw ''
          }
        } catch (error) {
          this.$swal('Alert!', 'End Date is invalid, must be between 01/01/2000 and 01/01/2100', 'warning')
          return false
        }

        return true
      },
      saveHaul() {
        this.inputBlur('water_percentage_actual')
        this.inputBlur('water_percentage_estimate')
        this.inputBlur('volume_actual')
        this.inputBlur('volume_estimate')
        if (!this.okToSave_h()) {
          return
        }
        this.savebtn=true
        let tempStartDateTime = new Date((this.newHaul.haul_start_datetime + " " + this.newHaul.haul_start_time).replace(/-/g, "/"))
        let tempEndDateTime = new Date((this.newHaul.haul_end_datetime + " " + this.newHaul.haul_end_time).replace(/-/g, "/"))

        let haul_start_datetime = String(tempStartDateTime.getFullYear()) + "-" + ("0" + String(tempStartDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempStartDateTime.getDate())).slice(-2) + " " + tempStartDateTime.toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
        });
        let haul_end_datetime = String(tempEndDateTime.getFullYear()) + "-" + ("0" + String(tempEndDateTime.getMonth() + 1)).slice(-2) + "-" + ("0" + String(tempEndDateTime.getDate())).slice(-2) + " " + tempEndDateTime.toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
        });

        let saveData = {
          "energy_companies_id": String(this.newHaul.energy_companies_id),
          "users_id": String(this.newHaul.user_id),
          "fluid_type_id": String(this.newHaul.fluid_type_id),
          "load_location_id": String(this.newHaul.load_location_id),
          "unload_location_id": String(this.newHaul.unload_location_id),
          "truck_id": String(this.newHaul.truck_id),
          "trucks_unit_id": String(this.newHaul.truck_unit_id),
          "haul_start_datetime": haul_start_datetime,
          "haul_end_datetime": haul_end_datetime,
          "volume_estimate": String(this.newHaul.volume_estimate),
          "volume_actual": String(this.newHaul.volume_actual),
          "water_percentage_estimate": String(this.newHaul.water_percentage_estimate),
          "water_percentage_actual": String(this.newHaul.water_percentage_actual),
          "terminal_ticket": String(this.newHaul.t_ticket),
          "truck_ticket": String(this.newHaul.ticket),
          "terminal_boss_ticket_id": String(this.newHaul.t_boss),
          "chain_up_required": this.newHaul.chain_up,
          "total_distance": "0",
          "comments_start": String(this.newHaul.comments_start),
          "comments_end": String(this.newHaul.comments_end),
          "waypoints": "",
          "trip_pictures": "",
          "wait_times": this.newHaul.wait_times.map((item) => {
            return { ...item,
              time: this.hmsToSecondsOnly(item.time)
            }
          })
        }
        haul_service.save(saveData)
          .then(data => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.newEC = false
                  this.getAll()
                }
              })
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
          })
          this.savebtn=false
      },
      inputBlur(variableName) {
        let variableValue = this.newHaul[variableName]
        if (variableValue.length == 0) {
          this.newHaul[variableName] = "0.00"
        } else {
          let tempValue = variableValue.split(".")
          if (tempValue.length == 1) {
            this.newHaul[variableName] = String(variableValue) + ".00"
          } else if (tempValue.length == 2) {
            this.newHaul[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
          }
        }
      },
      get_trucking_companies() {
        haul_service.get_trucking_hauls()
          .then((data) => {
                if (data.status  == 'success') {
                    this.insert_data = data.insert_data
                    let trucking_companies = this.insert_data.trucking_companies
                    if (this.role =='super_admin') {
                    
                      this.newHaul.truck_company_select = trucking_companies.map((item) => {
                               return {
                                        'value': item.id,
                                        'text': item.name
                                      }
                      }) 
        
                    }

                    else if  (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
                      if (trucking_companies.length > 0) {
                        this.newHaul.truck_company_id = trucking_companies[0].id

                        let drivers = trucking_companies[0]['drivers']

                        this.newHaul.driver_select = drivers.map((item) => {
                            return {
                              'value': item.id,
                              'text': item.name
                            }
                        })
                        let trucks = trucking_companies[0]['trucks']
                        this.newHaul.truck_select = trucks.map((item) => {
                            return {
                              'value': item.id,
                              'text': item.truck_name
                            }
                        })
                        let truck_units = trucking_companies[0]['truck_units']
                        this.newHaul.truck_unit_select = truck_units.map((item) => {
                          return {
                            'value': item.id,
                            'text': item.truck_unit
                          }
                        })
                        if (this.newHaul.truck_unit_select.length == 1) {
                          this.newHaul.truck_unit = this.newHaul.truck_select[0].text
                          this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value
                        }
                        // SAME as in APP - Select if there is only one item in the array
                        if (this.newHaul.driver_select.length == 1) {
                          this.newHaul.full_name = this.newHaul.driver_select[0].text
                          this.newHaul.user_id = this.newHaul.driver_select[0].value
                        }
                        if (this.newHaul.truck_select.length == 1) {
                          this.newHaul.truck = this.newHaul.truck_select[0].text
                          this.newHaul.truck_id = this.newHaul.truck_select[0].value
                        }
                      }
                }
              } else {
										this.$swal(data.status, data.message, data.status)
              }
          })
          .catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
          })
      },
      selects_trucking_company() {

        if (this.role =='super_admin') {
          this.newHaul.user_id = ''
          this.newHaul.full_name = ''
          this.newHaul.truck_id = ''
          this.newHaul.truck = ''
          this.newHaul.truck_unit_id = ''
          this.newHaul.truck_unit = ''
          let trucking_companies = this.insert_data.trucking_companies

          let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.newHaul.truck_company_id)
          if (current_truck_company_index > -1) {
            let drivers = trucking_companies[current_truck_company_index]['drivers']
            this.newHaul.driver_select = drivers.map((item) => {
              return {
                'value': item.id,
                'text': item.name
              }
            })
            let trucks = trucking_companies[current_truck_company_index]['trucks']
            this.newHaul.truck_select = trucks.map((item) => {
             return {
                'value': item.id,
                'text': item.truck_name
              }
            })
            let truck_units = trucking_companies[current_truck_company_index]['truck_units']
            this.newHaul.truck_unit_select = truck_units.map((item) => {
             return {
                'value': item.id,
                'text': item.truck_unit
              }
            })
            if (this.newHaul.truck_unit_select.length == 1) {
              this.newHaul.truck_unit = this.newHaul.truck_select[0].text
              this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value
            }
            // SAME as in APP - Select if there is only one item in the array
            if (this.newHaul.driver_select.length == 1) {
              this.newHaul.full_name = this.newHaul.driver_select[0].text
              this.newHaul.user_id = this.newHaul.driver_select[0].value
            }
            if (this.newHaul.truck_select.length == 1) {
              this.newHaul.truck = this.newHaul.truck_select[0].text
              this.newHaul.truck_id = this.newHaul.truck_select[0].value
            }
          }
        } else if  (this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {

                this.newHaul.user_id = ''
                this.newHaul.full_name = ''
                this.newHaul.truck_id = ''
                this.newHaul.truck = ''
                this.newHaul.truck_unit_id = ''
                this.newHaul.truck_unit = ''
                if (this.insert_data.trucking_companies.length>0) {
                  let trucking_companies = this.insert_data.trucking_companies
                  this.newHaul.truck_company_id = trucking_companies[0].id
                  let drivers = trucking_companies[0]['drivers']
                  this.newHaul.driver_select = drivers.map((item) => {
                    return {
                    'value': item.id,
                    'text': item.name
                    }
                  })
                  let trucks = trucking_companies[0]['trucks']
                  this.newHaul.truck_select = trucks.map((item) => {
                    return {
                    'value': item.id,
                    'text': item.truck_name
                    }
                  })
                  let truck_units = trucking_companies[0]['truck_units']
                  this.newHaul.truck_unit_select = truck_units.map((item) => {
                  return {
                      'value': item.id,
                      'text': item.truck_unit
                    }
                  })
                  if (this.newHaul.truck_unit_select.length == 1) {
                    this.newHaul.truck_unit = this.newHaul.truck_select[0].text
                    this.newHaul.truck_unit_id = this.newHaul.truck_select[0].value
                  }
                  // SAME as in APP - Select if there is only one item in the array
                  if (this.newHaul.driver_select.length == 1) {
                    this.newHaul.full_name = this.newHaul.driver_select[0].text
                    this.newHaul.user_id = this.newHaul.driver_select[0].value
                  }
                  if (this.newHaul.truck_select.length == 1) {
                    this.newHaul.truck = this.newHaul.truck_select[0].text
                    this.newHaul.truck_id = this.newHaul.truck_select[0].value
                  }
                }
        }
      },
      selects_energy_company() {
        this.newHaul.load_location_select = []
        this.newHaul.load_location = ''
        this.newHaul.load_location_id = ''
        let trucking_companies = this.insert_data.trucking_companies

        let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.newHaul.truck_company_id)
        if (current_truck_company_index > -1) {
          let drivers = trucking_companies[current_truck_company_index]['drivers']
          let drivers_index = drivers.map(o => o.id).indexOf(this.newHaul.user_id)
          if (drivers_index > -1) {
            let energycompanies = drivers[drivers_index]['energy_companies']
            let energy_company_index = energycompanies.map(o => o.id).indexOf(this.newHaul.energy_companies_id)
            this.getLoadLocation (energycompanies[energy_company_index].id, drivers[drivers_index].id)
          }
        }
      },
      getLoadLocation (energy_company_id,driver_id) {
        haul_service.getLoadLocation(energy_company_id,driver_id)
          .then(data => {
                if (data['status'] == 'success') {
                  this.loads_locations = data['load_locations']
                   this.newHaul.load_location_select = this.loads_locations.map((item) => {
                     return {
                       'value': item.id,
                       'text': item.legal_location
                     }
                   })
                   if (this.newHaul.load_location_select.length == 1) {
                       this.newHaul.load_location = this.newHaul.load_location_select[0].text
                       this.newHaul.load_location_id = this.newHaul.load_location_select[0].value
                     }
                } else {
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      selects_driver() {
        // alert()
        this.newHaul.energy_companies_id = ''
        this.newHaul.energy_company = ''
        this.newHaul.unload_location_select = []
        this.newHaul.unload_location = ''
        this.newHaul.unload_location_id = ''

        let trucking_companies = this.insert_data.trucking_companies
        let current_truck_company_index = trucking_companies.map(o => o.id).indexOf(this.newHaul.truck_company_id)
        if (current_truck_company_index > -1) {
          let drivers = trucking_companies[current_truck_company_index]['drivers']
          let drivers_index = drivers.map(o => o.id).indexOf(this.newHaul.user_id)
          let energycompanies = drivers[drivers_index]['energy_companies']
          this.newHaul.energy_company_select = energycompanies.map((item) => {
            return {
              'value': item.id,
              'text': item.company_name
            }
          })
          this.getUnloadLocation (drivers[drivers_index].id)
        }
      },
      getUnloadLocation (driver_id) {
        haul_service.getUnloadLocation(driver_id)
          .then(data => {
                if (data['status'] == 'success') {
                  let loads_locations = data['unload_locations']
                    this.newHaul.unload_location_select = loads_locations.map((item) => {
                      return {
                        'value': item.id,
                        'text': item.legal_location
                      }
                    })
                } else {
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      selects_load_location() {

        this.newHaul.fluid_type_select = []
        this.newHaul.fluid_type = ''
        this.newHaul.fluid_type_id = ''
        let loads_locations = this.loads_locations
        let loads_locations_index = loads_locations.map(o => o.id).indexOf(this.newHaul.load_location_id)
        if (loads_locations_index > -1) {
          let fluid_types = loads_locations[loads_locations_index]['fluids']
          this.newHaul.fluid_type_select = fluid_types.map((item) => {
            return {
              'value': item.id,
              'text': item.name
            }
          })
        }
      },
      myOnlyNumber(evt, variableName) {
        let dotPosition = this.newHaul[variableName].indexOf(".")
        let hasDot = dotPosition > -1
        let length = this.newHaul[variableName].length
        this.isNumber(evt, hasDot, dotPosition, length)
      },
      isNumber: function(evt, hasDot, dotPosition, length) {

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
          let selectionStart = evt.target.selectionStart;
          let selectionEnd = evt.target.selectionEnd;
          if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
            evt.preventDefault();
          } else {
            return true
          }
        } else {
          evt.preventDefault();
        }
      },
      approvedFilter(apr_filter) {
        if (this.role =='super_admin' || this.role =='trucking_company_admin' || this.role =='trucking_operational_manager') {
          let itemsO = this.itemsAll
          this.Approved = apr_filter
          if (apr_filter==='Approved') {     
            let result = itemsO.filter(item => {return item.trucking_company_approved ==true})
            this.items = result
            //this.haul_ids = this.haul_iidds 
            //this.filters_save.flag_name ='Approved'
          } else if (apr_filter==='Unapproved') {
            let result = itemsO.filter(item => {return item.trucking_company_unapproved ==true})
            this.items = result
            //this.haul_ids = this.haul_iiddss
            //this.filters_save.flag_name ='Unapproved'
          } else {
            this.items = this.itemsAll
            this.haul_ids = []
            this.Approved = 'Show Approved'
          }
        }
      },
      h_approved_click(){
        let model = {
          command:'approved',
          approved : this.haul_ids
        }
        this.haul_ids = []
        haul_service.HaulsApproved(model)
          .then((data) => {
            if (data.status == 'success') {
              Vue.swal(data.status, data.message, data.status)
              this.getAll()
              this.loadingData = true
            }else{
              Vue.swal(data.status, data.message, data.status)

            }
          })
      },
      h_deapproved_click() {
        let model = {
          command  :'unapproved',
          unapproved : this.haul_ids
        }
        this.haul_ids = []
        haul_service.HaulsApproved(model)
          .then((data) => {
            if (data.status == 'success') {
              Vue.swal(data.status, data.message, data.status)
              this.getAll()
              this.loadingData = true
            }else{
              Vue.swal(data.status, data.message, data.status)

            }
          })
      },
      h_unasigned_click() {
        let model = {
          command  :'unasigned',
          unasigned : this.haul_ids
        }
        this.haul_ids = []
        invoices_service.HaulsUnasigned(model)
          .then((data) => {
            if (data.status == 'success') {
              Vue.swal(data.status, data.message, data.status)
              this.getAll()
              this.loadingData = true
            }else{
              Vue.swal(data.status, data.message, data.status)

            }
          })
      },
      keyMonitor1(evt) {
				if(evt.key.match(/[a-zA-Z0-9]/i)===null) {
						evt.preventDefault()
						return					
				} else {
					evt = (evt) ? evt : window.event;
					let key = evt.key
					if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown")  {
						return
					} else if (key == "Backspace" ) {
						let filter_txt = this.newHaul.t_ticket
						let nn 				= filter_txt.length - 1
						if (nn>0) {
							this.newHaul.t_ticket = filter_txt.substring(0, nn)
							return
						} else {
							  this.newHaul.t_ticket  = ''
							return
						}
						
					} else if (key == "Delete" ) {
						return
					} else {
              
              let filter_txt = this.newHaul.t_ticket
              let nn 				= filter_txt.length
              if (nn<10) {               
                filter_txt = filter_txt + key
                this.newHaul.t_ticket = filter_txt
              } else {
                evt.preventDefault()
              }
						  return					
					}
				}
			},
      keyMonitor(evt) {
				if(evt.key.match(/[a-zA-Z0-9]/i)===null) {
						evt.preventDefault()
						return					
				} else {
					evt = (evt) ? evt : window.event;
					let key = evt.key
					if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown")  {
						return
					} else if (key == "Backspace" ) {
						let filter_txt = this.newHaul.ticket
						let nn 				= filter_txt.length - 1
						if (nn>0) {
							this.newHaul.ticket = filter_txt.substring(0, nn)
							return
						} else {
							  this.newHaul.ticket  = ''
							return
						}
						
					} else if (key == "Delete" ) {
						return
					} else {
              
              let filter_txt = this.newHaul.ticket
              let nn 				= filter_txt.length
              if (nn<10) {               
                filter_txt = filter_txt + key
                this.newHaul.ticket = filter_txt
              } else {
                evt.preventDefault()
              }
						  return					
					}
				}
			},
  }
}
</script>

<style lang="scss" scoped>
  .show-details-cell{
    font-weight: 500;
    cursor: pointer;
  }
  .table-controls{
    padding: 14px 16px 0 16px;
  }
  /deep/ .table{
    margin: 0;
    td{
      white-space: nowrap;
      vertical-align: middle;
    }
    th{
      white-space: nowrap;
      vertical-align: middle;
    }
    td> div{
      line-height: 1;
    }
    .b-table-details> td {
      background-color: #FFFDF0;
    }
    .b-table-details h6{
      padding: 0;
      margin: 0;
      font-size: 0.8rem;
      line-height: 16px;
      margin-bottom: 8px;
      color: #676973;
    }
    .b-table-details p{
      font-size: 16px;
      color: #3A3E4D;
      padding: 0;
      margin: 0;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .details-container{
      position: relative;
      white-space: normal; 
      display: flex; 
      flex-direction: row;
      flex-wrap: nowrap; 
      justify-content: flex-start;
      .item{
        padding-left: 10px;
        padding-right: 10px;
      }
      .item.location{
        width: 180px;
      }
      .item.ticket{
        width: 130px;
      }
      .item.date{
        width: 180px;
      }
      .item.volume{
        min-width: 100px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 20px;
        height: 100%;
        border-top: 1px solid #bcbcbc;
      }
      &::before{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 2px;
        height: 100%;
        border-left: 1px solid #bcbcbc;
      }
    }
    .details-container:last-child::before{
      display: none;
    }
  }
  /deep/ .btn-secondary{
    background: #ffffff;
  }
  /deep/ .custom-control {
    margin: 0;
    padding-left: 1rem;
  }
  /deep/ .select_column{width: 2%}
  /deep/ .bulk-action-controls{
    .dropdown{
      display: block;
      width: 100%;
    }
    .dropdown-toggle{
      display: block;
      width: 100%;
      text-align: left;
    }
    .dropdown-toggle::after {
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -2px;
    }
    .close-controls{
      font-size: 18px; 
      font-weight: bold;
      height: 35px; 
      line-height: 14px;
      cursor: pointer;
      padding: 8px;
    }
    .btn-secondary{
      border-color: #cacaca;
    }
    .btn-select{
      height: 35px;
      margin-bottom: auto;
      margin-top: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/invoices/haul_invoices.vue